const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "menu":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "menu",
    reducer: reducer,
};

export default data;